import { useEffect, useRef } from 'react';

import { GlobeIcon } from '@braskai/icons';
import { useLocalStorage } from 'react-use';

import { useBalanceStore } from '@/entities/balance';
import { useCurrentUser } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { useInterfaceLanguage } from '@/shared/i18n';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PromoBanner } from '@/shared/ui/PromoBanner';

const LS_SHOW_SIDEBAR_BANNER = 'showSidebarBanner';

export const ApiBannerSidebar = () => {
  const { t } = useInterfaceLanguage();
  const [show, setShowBanner] = useLocalStorage(LS_SHOW_SIDEBAR_BANNER, true);

  const isFirstLoadRef = useRef<boolean>(false);

  const { data: user } = useCurrentUser();
  const { api_credentials_generated: apiCredentialsGenerated } = user ?? {};

  const { hasActiveSubscription, hasTrialPlan } = useBalanceStore();

  const isApiAvailable = hasActiveSubscription && !hasTrialPlan;

  const handleClose = () => {
    setShowBanner(false);
    MixpanelEvents.apiBannerClose();
  };

  const handleClickLink = () => {
    MixpanelEvents.apiBannerClick();
  };

  const isShowBanner = show && !apiCredentialsGenerated && !IS_WHITE_LABEL;

  useEffect(() => {
    if (isShowBanner && !isFirstLoadRef.current) {
      isFirstLoadRef.current = true;
    }
  }, [isShowBanner]);

  if (!isShowBanner) {
    return null;
  }

  return (
    <PromoBanner
      title={t('sidebar.api.title')}
      link={{
        children: isApiAvailable ? t('sidebar.api.getKey') : t('common.upgrade'),
        to: `/${isApiAvailable ? PATHS.account : PATHS.pricing}`,
        onClick: handleClickLink,
      }}
      icon={<GlobeIcon />}
      variant="primary"
      onClose={handleClose}
    />
  );
};
